// interceptor for attaching headers to outgoing requests
import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificationService } from '../_services/notification.service';
import { TranslationService } from '../_services/translation.service';
import { UserService } from '../_services/user.service';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationInterceptor implements HttpInterceptor {
	constructor(
		public notificationService: NotificationService,
		public t: TranslationService,
		public userService: UserService
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// add events api headers
		if (request.url.includes(environment.apiUrl)) {
			// if a post-init config request (e.g. from teams invite accept) do not alter headers
			if (request.url.includes('/config?container_name=')) {
				return next.handle(request);
			}

			// if a login request do not overwrite custom Auth header
			if (request.url.includes('/user/account/login')) {
				const loginHeaders = JSON.parse(
					JSON.stringify(this.userService.headers)
				);
				delete loginHeaders['Authorization'];
				const loginModified = request.clone({
					setHeaders: loginHeaders
				});
				return next.handle(loginModified);
			}
			
			// remove grip version header to get all extensions for all platforms
			if (request.url.includes('/extensions') && request.headers.has('X-Skip-Version')) {
				const extensionsHeaders = JSON.parse(
					JSON.stringify(this.userService.headers)
				);
				delete extensionsHeaders['X-Grip-Version'];
				const extensionsModified = request.clone({
					setHeaders: extensionsHeaders
				});
				return next.handle(extensionsModified);
			}

			// if a picture update url remove Content-Type: application/json
			if (request.url.includes('/picture') || request.url.includes('/image')) {
				const imgHeaders = JSON.parse(JSON.stringify(this.userService.headers));
				delete imgHeaders['Content-Type'];
				const imgModified = request.clone({
					setHeaders: imgHeaders
				});
				return next.handle(imgModified);
			}

			// add standard auth headers
			const modified = request.clone({
				setHeaders: this.userService.headers
			});
			return next.handle(modified);
		}

		// add teams api headers
		if (request.url.includes(environment.teamsApiUrl)) {
			// if a login request do not overwrite custom Auth header
			if (request.url.includes('/user/account/login')) {
				const loginHeaders = JSON.parse(
					JSON.stringify(this.userService.headers)
				);
				delete loginHeaders['Authorization'];
				const loginModified = request.clone({
					setHeaders: loginHeaders
				});
				return next.handle(loginModified);
			}

			// add standard teams auth headers
			const modified = request.clone({
				setHeaders: this.userService.teamsHeaders
			});
			return next.handle(modified);
		}

		// add no headers
		return next.handle(request);
	}
}
